import React, { useContext } from 'react'
import AllComp from '../components/AllComp'
import { Link, useParams } from 'react-router'
import { apivalue } from '../Data/AllData';

function AllSingleproduct() {
    const { id } = useParams();
    const data = useContext(apivalue);
    return (
        <div>
            <AllComp />
            <div className='property-details py-5'>
                <div className='container'>
                    {data.map((item) => {
                        return item.id == id ? (
                            <div key={item.id} className='row align-items-center'>
                                
                                <div className='col-lg-6 col-md-12 mb-4'>
                                    <img
                                        src={item.images[0]}
                                        alt={item.title}
                                        className='img-fluid rounded shadow-sm'
                                        style={{ width: "100%", height: "auto", borderRadius: "15px" }}
                                    />
                                </div>

                                
                                <div className='col-lg-6 col-md-12'>
                                    <span className="category text-uppercase text-muted">{item.category}</span>
                                    <h2 className='fw-bold mt-2 mb-3'>{item.title}</h2>
                                    <h4 className='text-primary mb-4'>${item.price.toLocaleString()}</h4>

                                    <ul className='list-unstyled'>
                                        <li><strong>ID:</strong> {item.id}</li>
                                        <li><strong>Rating:</strong> {item.rating}</li>
                                        
                                        <li><strong>Discount:</strong> {item.discountPercentage}%</li>
                                       
                                    </ul>

                                    <p className='mt-4 text-secondary'>
                                        Discover your dream property with spacious design, modern interiors, and stunning views.
                                        Perfect for families seeking comfort and elegance.
                                    </p>

                                    <div className="main-button mt-4">
                                        <Link to={"/Products"} className='btn btn-dark px-4 py-2 rounded-pill'>
                                            Back
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        ) : null;
                    })}
                </div>
            </div>

        </div>
    )
}

export default AllSingleproduct
